module.exports = __webpack_public_path__ + "static/laingSimmons-5e89683149a7ddc1cd790a49cdb47d2a.svg";